export default {
  'creator.email'                          : 'E-mail',
  'creator.email.placeholder'              : 'Your email address',
  'creator.name'                           : 'Full name',
  'creator.name.placeholder'               : 'Your name',
  'creator.worksFor.name'                  : 'Organization name',
  'creator.worksFor.name.placeholder'      : 'Your organization\'s name',
  'creator.jobTitle'                       : 'Job title',
  'creator.jobTitle.placeholder'           : 'Your job title',
  'commentText'                            : 'Message',
  'commentText.placeholder'                : 'Type message (limit to 300 characters)',
  'image'                                  : 'Main image',
  'image.placeholder'                      : 'Upload the author’s photograph or the organization’s logo',
  'attachments'                            : 'Upload/provide a link to a video and/or written statement',
  'attachments.placeholder'                : 'If your video is on YouTube, please provide a link. Otherwise, upload a video (.mp4) using the “Add file” button below. For messages without a video link, Please upload the text version of your message as a document (.doc or .pdf)',
  'creator.worksFor.country'               : 'Country',
  'creator.worksFor.country.placeholder'   : 'Select your organization\'s country',
  'type'                                   : 'Organization Type',
  'type.placeholder'                       : ' ',
  'name'                                   : 'Title',
  'name.placeholder'                       : ' ',
  'useAccount.placeholder':'',
  'useAccount': 'Use your SCBD account profile data to populate the form?',
  'Your document has been submitted and is waiting review':'Your document has been submitted and is waiting review',
  'You document has been submitted':'You document has been submitted'
}